var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('eve-regulatory-thresholds',{attrs:{"data":_vm.activeEveAnalysis,"title":_vm.$t('Dashboard.Banking.InterestRateRisk.RegulatoryThresholds.Title'),"dashboard-view":"","title-icon":"grey","title-icon-size":"5"}})}
var staticRenderFns = []

export { render, staticRenderFns }